import { render, staticRenderFns } from "./VerzorgingsplaatsenRwsLayer.vue?vue&type=template&id=deeddc38&"
import script from "./VerzorgingsplaatsenRwsLayer.vue?vue&type=script&lang=js&"
export * from "./VerzorgingsplaatsenRwsLayer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports